import { message } from 'antd';
import actions from './actions';
import { DataService } from '../../config/dataService/dataService';
import { logOut } from '../authentication/actionCreator';
import { getItem } from '../../utility/localStorageControl';

const {
  projectAddBegin,
  projectAddSuccess,
  projectAddErr,

  projectReadBegin,
  projectReadSuccess,
  projectReadErr,

  projectUpdateSuccess,
  projectUpdateErr,
  projectUpdateBegin,

  projectDeleteSuccess,
  projectDeleteErr,
  projectDeleteBegin,


  // productReadBegin,
  // productReadSuccess,
  // productReadErr,

} = actions;


// const productDataRead = () => {
//   return async (dispatch) => {
//     try {
//       await dispatch(productReadBegin());
//       const response = await DataService.get(`/products`);
//       const token = getItem('access_token');
//       if (token && response !== null && response.data.Error === false) {
//         await dispatch(productReadSuccess(response.data.payload));
//       } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
//         message.error(response.data.message);
//         await dispatch(productReadSuccess(null));
//       }
//       else {
//         if (response.data.Error === true && response.data.statusCode === 401) {
//           message.error(response.data.message);
//           await dispatch(productReadSuccess(null));
//           dispatch(logOut())
//         }
//       }
//     } catch (err) {
//       await dispatch(productReadErr(err));
//       if (err.message === "Network Error") {
//         message.error("Server is down, please contact developer team")
//         dispatch(logOut())
//       } else {
//         message.error(err.message);
//       }
//     }
//   };
// };


const projectDataSubmit = (data) => {
  return async (dispatch) => {
    try {
      await dispatch(projectAddBegin());
      const response = await DataService.post('/projects/create', data);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(projectAddSuccess(response.data));
        message.success(response.data.message);
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(projectAddSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(projectAddSuccess(null));
          dispatch(logOut());
        }
      }
    } catch (err) {
      await dispatch(projectAddErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};

const projectDataDelete = (id) => {
  return async (dispatch) => {
    try {
      await dispatch(projectDeleteBegin());
      const response = await DataService.delete(`/projects/delete/${id}`);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(projectDeleteSuccess(response.data));
        message.success(response.data.message);
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(projectDeleteSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(projectDeleteSuccess(null));
          dispatch(logOut());
        }
      }
    } catch (err) {
      await dispatch(projectDeleteErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};

const projectDataRead = () => {
  return async (dispatch) => {
    try {
      await dispatch(projectReadBegin());
      const response = await DataService.get(`/projects`);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(projectReadSuccess(response.data.payload));
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(projectReadSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(projectReadSuccess(null));
          dispatch(logOut())
        }
      }
    } catch (err) {
      await dispatch(projectReadErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};

const projectDataUpdate = (data) => {
  return async (dispatch) => {
    try {
      await dispatch(projectUpdateBegin());
      const response = await DataService.put(`/projects/update`, data);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(projectUpdateSuccess(response.data));
        message.success(response.data.message);
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(projectUpdateSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(projectUpdateSuccess(null));
          dispatch(logOut())
        }
      }
    } catch (err) {
      await dispatch(projectUpdateErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};

export {
  projectDataRead,
  projectDataSubmit,
  projectDataUpdate,
  projectDataDelete
};
